import { mediaBreakpointUp } from '@mote/ui/theme/core/breakpoints'
import styled from '@xstyled/styled-components'

export const StyledLandingMainLayout = styled.divBox<{
  isAuthenticated: boolean
}>(
  {
    display: 'grid',
    gridTemplateColumns: '1fr',
    justifyItems: 'center',
    minHeight: '100%',
    backgroundColor: 'white',
    '& div:last': {
      marginBottom: 0,
      paddingBottom: 80,
      [mediaBreakpointUp('md')]: {
        paddingBottom: 120
      }
    }
  },
  props =>
    props.isAuthenticated && {
      borderRadius: 0,
      [mediaBreakpointUp('md-lg')]: {
        borderRadius: '1.5rem 0 0'
      }
    }
)

export const StyledLandingMainLayoutContent = styled.div({
  position: 'relative',
  width: '100%',
  marginBottom: 24,
  padding: '58px 16px 0',
  [mediaBreakpointUp('md')]: {
    padding: '72px 24px 0'
  },
  [mediaBreakpointUp('lg')]: {
    marginBottom: 40,
    padding: '72px 40px 0'
  },
  '&:last-child': {
    marginBottom: 0,
    paddingBottom: 80,
    [mediaBreakpointUp('md')]: {
      paddingBottom: 120
    }
  }
})

export const StyledCreatorData = styled.div({
  maxWidth: 748,
  display: 'flex',
  alignItems: 'baseline',
  margin: '0 auto 12px',
  padding: '0 12px',
  '> *:not(:last-child)': {
    marginRight: 8
  }
})

export const StyledTitle = styled.div({
  maxWidth: 748,
  padding: '0 0.25rem',
  margin: '0 auto 0.25rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem'
})
